import gql from 'graphql-tag';

export const UPDATE_USER = gql`
  mutation ($locale: String!, $timezone: String) {
    updateUser(
      input: {
        locale: $locale,
        timezone: $timezone
     }
    ) {
      userId
    }
}
`;
